module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/PrinceOfPersia_xbox_lrg.b47a227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/PrinceOfPersia_xbox_lrg.jpg
// module id = Y8Lx
// module chunks = 0